module.exports = __webpack_public_path__ + "img/sealImg2.04346a13.png";